// extracted by mini-css-extract-plugin
module.exports = {"layout":"Footer-module--layout--6Psvw","footer":"Footer-module--footer--112zW","fine_print":"Footer-module--fine_print--2lV3j","social_link":"Footer-module--social_link--CRzvZ"};